export default [
    'bis',
    'durch',
    'entlang',
    'für',
    'gegen',
    'ohne',
    'um',
    'wider'
];


/** WEBPACK FOOTER **
 ** ./app/components/pages/exercisePages/Prepositions/accusativePrepositions.js
 **/